module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('p', {
    staticStyle: {
      "width": "1280px",
      "margin": "0 auto"
    }
  }, [(_vm.englishpc == 1) ? _c('span', {
    staticClass: "language",
    class: {
      active: _vm.language === 'en' ? true : false
    },
    staticStyle: {
      "padding-right": "20px",
      "border-right": "1px solid #E6E6E6"
    },
    on: {
      "click": function($event) {
        _vm.changeLaguage('en')
      }
    }
  }, [_vm._v("English")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "language",
    class: {
      active: _vm.language === 'ch' ? true : false
    },
    staticStyle: {
      "margin-left": "20px",
      "margin-right": "50px"
    },
    on: {
      "click": function($event) {
        _vm.changeLaguage('ch')
      }
    }
  }, [_vm._v("简体中文")]), _vm._v(" "), _c('span', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggle($event)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle",
      "margin-right": "5px"
    },
    attrs: {
      "src": require("../tpl3/images/login.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.login($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("message.tpl3.menu.login")))]), _vm._v(" "), (_vm.user != null) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  }, [_vm._v(_vm._s(_vm.user.uName))]) : _vm._e()]), _vm._v(" "), _c('span', {
    class: {
      'arrow-bottom': _vm.isLogin, arrow: !_vm.isLogin
    },
    staticStyle: {
      "margin-left": "5px"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTips),
      expression: "showTips"
    }],
    staticClass: "tips"
  }, [(_vm.isLogin && _vm.isregister == 1) ? _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.doReg
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("message.tpl1.menu.info")) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.logout($event)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  }, [_vm._v(_vm._s(_vm.$t("message.tpl3.menu.logout")))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69078f00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerTop/headerTop.vue
// module id = 810
// module chunks = 10